export function ErrorAlert({ message }: { message: string }) {
  return (
    <div className="bg-danger-50 border border-danger-200 text-danger-700 px-4 py-3 rounded-lg mb-4 flex items-start gap-3">
      <span className="text-lg leading-none">⚠️</span>
      <div className="text-sm font-medium">{message}</div>
    </div>
  );
}
